import { Box, Typography } from "@mui/material";
import { CardCore } from "../CardCore/CardCore"


import { FormatMoney } from "src/shared/Utils/FormatMoney";
import { EmojiEventsOutlinedIcon } from "../Icons/Icons";


interface ICardHighlightProducer {
  title: string;
  name: string;
  document: string;
  countSales: string;
  valueProduction: string;
}

export const CardHighlightProducer = ({ title, name, document, countSales, valueProduction }: ICardHighlightProducer) => {
  return (
    <CardCore
      sxStyle={{
        height: { xs: "150px", sm: "170px" },
        margin: "0",
        padding: "20px",
        border: "1px solid #CED5FFFF",
        background: "linear-gradient(135deg, #FFFFFFFF 30%, #D6DCFFFF 100%)",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", mb: "16px" }}>
        <EmojiEventsOutlinedIcon sx={{ color: "#FFDB5AF5", marginRight: "8px" }} />

        <Typography sx={{ fontSize: "0.9rem", fontWeight: "bold" }}>{title}</Typography>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
        <Typography sx={{ fontSize: "1rem", fontWeight: "bold", }}>
          {name}
        </Typography>
        <Typography sx={{ fontSize: "1.4rem", fontWeight: "bold", color: "#3D5AFEFF" }}>
          {countSales}
        </Typography>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: "16px" }}>
        <Typography sx={{ fontSize: "0.8em", color: "text.secondary" }}>
          {document}
        </Typography>
        <Typography sx={{ fontSize: "0.8rem", color: "text.secondary" }}>
          Vendas
        </Typography>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
        <Typography sx={{ fontSize: "0.9rem", color: "text.secondary", fontWeight: "bold" }}>
          Produção
        </Typography>
        <Typography sx={{ fontSize: "0.9rem", color: "success.main", fontWeight: "bold" }}>
          R$ {FormatMoney(valueProduction)}
        </Typography>
      </Box>
    </CardCore>
  )
}